(function () {
  if (window.__pitasCardSizeAtcBound) return;
  window.__pitasCardSizeAtcBound = true;

  var MQ = 1024;
  var sheetEl = null;
  var selectedId = null;
  var cache = Object.create(null);

  function isPlusViewport() {
    return window.innerWidth <= MQ;
  }

  function i18n(key, fallback) {
    var strings = window.T4Sstrings || {};
    return strings[key] || fallback;
  }

  function getHandle(btn, card) {
    return (
      btn.getAttribute('d-handle') ||
      btn.getAttribute('data-preorder-handle') ||
      (card && card.getAttribute('data-product-options')
        ? (function () {
            try {
              return JSON.parse(card.getAttribute('data-product-options')).handle;
            } catch (e) {
              return null;
            }
          })()
        : null) ||
      (btn.getAttribute('href') || '').split('/products/')[1] ||
      ''
    ).split('?')[0];
  }

  function sizeLabel(product, variant) {
    var options = product.options || [];
    var idx = -1;
    for (var i = 0; i < options.length; i++) {
      if (/talla|size|taille|größe|taglia/i.test(String(options[i]))) {
        idx = i;
        break;
      }
    }
    if (idx === -1 && options.length === 1) idx = 0;
    if (idx >= 0 && variant.options && variant.options[idx] != null) {
      return String(variant.options[idx]);
    }
    if (idx === 0 && variant.option1) return String(variant.option1);
    if (idx === 1 && variant.option2) return String(variant.option2);
    if (idx === 2 && variant.option3) return String(variant.option3);
    return String(variant.title || variant.option1 || '');
  }

  function fetchProduct(handle) {
    if (!handle) return Promise.reject(new Error('missing handle'));
    if (cache[handle]) return cache[handle];
    cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('product fetch failed');
      return res.json();
    });
    return cache[handle];
  }

  function setBodyLock(on) {
    document.documentElement.classList.toggle('pitas-card-size-sheet-open', !!on);
    document.body.classList.toggle('pitas-card-size-sheet-open', !!on);
  }

  function closeSheet() {
    if (!sheetEl) return;
    var el = sheetEl;
    sheetEl = null;
    selectedId = null;
    el.classList.remove('is--opened');
    setBodyLock(false);
    setTimeout(function () {
      if (el && el.parentNode) el.parentNode.removeChild(el);
    }, 220);
  }

  function isSheetOpen() {
    return !!(sheetEl && document.body.contains(sheetEl));
  }

  function addToCart(variantId) {
    if (!variantId) return;
    var btn = document.createElement('a');
    btn.href = '#';
    btn.setAttribute('data-action-atc', '');
    btn.setAttribute('data-variant-id', String(variantId));
    btn.setAttribute('data-qty', '1');
    btn.setAttribute('aria-hidden', 'true');
    btn.tabIndex = -1;
    btn.style.cssText = 'position:absolute;width:1px;height:1px;opacity:0;pointer-events:none;';
    document.body.appendChild(btn);
    try {
      var jq = window.jQuery_T4NT || window.jQuery;
      if (jq) {
        jq(btn).trigger('click');
      } else {
        btn.click();
      }
    } finally {
      setTimeout(function () {
        if (btn.parentNode) btn.parentNode.removeChild(btn);
      }, 50);
    }
  }

  function syncAtcState(panel) {
    var atc = panel.querySelector('[data-card-size-atc]');
    if (!atc) return;
    var label = atc.querySelector('.pitas-card-size-sheet__atc-text') || atc;
    var selected = panel.querySelector('[data-card-size-item].is--selected:not([disabled])');
    if (selected) {
      selectedId = selected.getAttribute('data-variant-id');
      atc.removeAttribute('disabled');
      atc.removeAttribute('aria-disabled');
      atc.classList.add('is--ready');
      label.textContent = i18n('add_to_cart', 'Añadir al carrito');
    } else {
      selectedId = null;
      atc.setAttribute('disabled', 'disabled');
      atc.setAttribute('aria-disabled', 'true');
      atc.classList.remove('is--ready');
      label.textContent = i18n('choose_an_option', 'Selecciona una opción');
    }
  }

  function openSheet(product, triggerBtn) {
    closeSheet();

    var variants = (product.variants || []).slice();
    var available = variants.filter(function (v) {
      return v.available;
    });

    if (!variants.length) {
      window.location.href = (triggerBtn && triggerBtn.getAttribute('href')) || '/products/' + product.handle;
      return;
    }

    if (variants.length === 1 && available.length === 1) {
      addToCart(available[0].id);
      return;
    }

    var root = document.createElement('div');
    root.className = 'pitas-card-size-sheet';
    root.setAttribute('data-card-size-sheet', '');
    root.innerHTML =
      '<div class="pitas-card-size-sheet__overlay" data-card-size-close></div>' +
      '<div class="pitas-card-size-sheet__panel" role="dialog" aria-modal="true" aria-label="' +
      i18n('choose_your_size', 'Elige tu talla') +
      '">' +
      '<div class="pitas-card-size-sheet__header">' +
      '<span class="pitas-card-size-sheet__title">' +
      i18n('choose_your_size', 'Elige tu talla') +
      '</span>' +
      '<button type="button" class="pitas-card-size-sheet__close" data-card-size-close aria-label="' +
      i18n('mfp_close', 'Close') +
      '">' +
      '<svg role="presentation" viewBox="0 0 16 14" width="14" height="14"><path d="M15 0L1 14m14 0L1 0" stroke="currentColor" fill="none" fill-rule="evenodd"></path></svg>' +
      '</button>' +
      '</div>' +
      '<div class="pitas-card-size-sheet__sizes" data-card-size-list></div>' +
      '<button type="button" class="pitas-card-size-sheet__atc" data-card-size-atc disabled aria-disabled="true">' +
      '<span class="pitas-card-size-sheet__atc-text">' +
      i18n('choose_an_option', 'Selecciona una opción') +
      '</span>' +
      '</button>' +
      '</div>';

    var list = root.querySelector('[data-card-size-list]');
    variants.forEach(function (variant) {
      var item = document.createElement('button');
      item.type = 'button';
      item.className = 'pitas-card-size-sheet__size';
      item.setAttribute('data-card-size-item', '');
      item.setAttribute('data-variant-id', String(variant.id));
      item.textContent = sizeLabel(product, variant);
      if (!variant.available) {
        item.disabled = true;
        item.setAttribute('aria-disabled', 'true');
        item.classList.add('is--soldout');
      }
      list.appendChild(item);
    });

    document.body.appendChild(root);
    sheetEl = root;
    setBodyLock(true);
    syncAtcState(root);

    requestAnimationFrame(function () {
      root.classList.add('is--opened');
    });
  }

  function onPlusClick(e) {
    if (!isPlusViewport()) return;
    var btn = e.target.closest('.t4s-product-btns2 [data-action-quickview]');
    if (!btn) return;

    var card = btn.closest('.t4s-product');
    if (!card) return;

    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

    if (isSheetOpen()) {
      closeSheet();
      return;
    }
    sheetEl = null;

    var handle = getHandle(btn, card);
    if (!handle) {
      window.location.href = btn.getAttribute('href') || '#';
      return;
    }

    btn.classList.add('is--loading');
    fetchProduct(handle)
      .then(function (product) {
        openSheet(product, btn);
      })
      .catch(function () {
        window.location.href = btn.getAttribute('href') || '/products/' + handle;
      })
      .finally(function () {
        btn.classList.remove('is--loading');
      });
  }

  function onDocClick(e) {
    if (!isSheetOpen()) return;

    if (e.target.closest('[data-card-size-close]')) {
      e.preventDefault();
      closeSheet();
      return;
    }

    var item = e.target.closest('[data-card-size-item]');
    if (item && sheetEl.contains(item)) {
      if (item.disabled || item.getAttribute('aria-disabled') === 'true') return;
      e.preventDefault();
      sheetEl.querySelectorAll('[data-card-size-item]').forEach(function (btn) {
        btn.classList.toggle('is--selected', btn === item);
      });
      syncAtcState(sheetEl);
      return;
    }

    var atc = e.target.closest('[data-card-size-atc]');
    if (atc && sheetEl.contains(atc)) {
      e.preventDefault();
      if (atc.disabled || !selectedId) return;
      atc.classList.add('is--loading');
      addToCart(selectedId);
      closeSheet();
    }
  }

  document.addEventListener('click', onPlusClick, true);
  document.addEventListener('click', onDocClick, false);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeSheet();
  });
  window.addEventListener(
    'resize',
    function () {
      if (!isPlusViewport()) closeSheet();
    },
    { passive: true }
  );
})();
